<template>
<div class="dash-text">
  <div class="dash-text__container">
    <div class="dash-text__text">
      <slot></slot>
    </div>
  </div>
</div>
</template>

<style lang="scss" scoped>
.dash-text {
  position: relative;
  z-index: 2;

  &__container {
    padding: 50px 180px 30px;

    .class-agro & {
      padding: 0 180px 30px;

      @media (max-width: 1275px) {
        padding: 0 50px 30px;
      }

      @media (max-width: 480px) {
        padding: 0 30px 20px;
      }
    }

    .class-mining & {
      padding: 0;
    }

    @media (max-width: 1275px) {
      padding: 50px 50px 30px;
    }

    @media (max-width: 480px) {
      padding: 30px 30px 20px;
    }
  }

  &__text {
    border-left: 5px #F8A81B solid;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
    padding-left: 10px;
    margin-left: -15px;

    .dash-text_blue & {
      border-left-color: #4DB6BC;
    }

    .dash-text_sky & {
      border-left-color: #4DB6BC;
    }

    .dash-text_green & {
      border-left-color: #27AE60;
    }

    .dash-text_coral & {
      border-left-color: #FF7D75;
    }

    .dash-text_violet & {
      border-left-color: #8293E8;
    }

    @media (max-width: 1275px) {
      margin-left: -15px;
    }
  }
}
</style>
